import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';

export default function getUserData() {
  const token = authService.getToken();
  const uid = authService.uid();

  const client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
    header: {
      Authorization: `Bearer ${token}`,
    },
  });

  return client.get('users', uid, { include: ['organisation'] })
    .then(user => user.toJSONTree())
    .catch(error => {
      reportError('LOAD_USER_ERROR', error.message);
    });
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/utils.js
 **/